(function TripSummaryAddComponent($, Adzuki)
{
	'use strict';

	// TS-391: one-liners per component type, shared with the day-header "+" menu
	// (ts_schedule_day.js) so the two pickers describe a type the same way.
	const typeDescriptions = {
		lodging       : 'Hotels & all-inclusive resorts',
		cruise        : 'Sailings & cruisetours',
		air           : 'Flights, one way or round trip',
		transportation: 'Transfers & car rentals',
		rail          : 'Train travel',
		excursion     : 'Tours & activities',
		custom        : 'Your own free-form section',
		info          : 'Notes, tips & reminders',
	};

	Adzuki.TripSummaryTypeDescriptions = typeDescriptions;

	const component = {
		emits : ['add'],
		inject: ['getFaIconStyle'],
		props : {
			componentTypes: {
				type   : Array,
				default: [],
			},
			label: {
				type   : String,
				default: 'Add Component',
			},
			classes: {
				type   : String,
				default: '',
			},
		},
		template: '#ts-add-component',
		data() {
			return {
				addingComponent : false,
				typeDescriptions: typeDescriptions,
			};
		},
		mounted() {
			// the builder keeps this page alive when the component modal opens —
			// reset the button spinner and close the drawer
			this.componentModalOpenHandler = () => {
				this.addingComponent = false;
				this.closeDrawer();
			};

			document.addEventListener('ts-component-modal-open', this.componentModalOpenHandler);
		},
		beforeUnmount() {
			document.removeEventListener('ts-component-modal-open', this.componentModalOpenHandler);
		},
		methods: {
			addComponent(component) {
				this.addingComponent = true;
				this.$emit('add', component);
			},
			closeDrawer() {
				const toggle = this.$refs.drawerToggle;

				if (toggle && window.bootstrap) {
					bootstrap.Dropdown.getOrCreateInstance(toggle).hide();
				}
			},
			typeDescription(type) {
				return this.typeDescriptions[type] || '';
			},
		},
	};

	Adzuki.VueComponents.TripSummaryAddComponent = component;
}(jQuery, window.Adzuki || {}));
